module.exports = __webpack_public_path__ + "adb5ca042fc3df9e134e912d35bd8431.svg";